import { Button, Spinner } from 'react-bootstrap';
import React from 'react';

/**
 * A reusable button component for submitting forms, with optional loading state.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.isSubmitting - A boolean value that determines whether the button should be disabled while the form is being submitted.
 * @param {boolean} props.isSubmitSuccessful - A boolean value that indicate the form was successfully submitted without any runtime error.
 * @param {string} props.defaultLabel - The text to display on the button.
 * @param {string} props.loadingLabel - The text to display on the button when submitting.
 * @param {Object} props.rest - Any additional props to pass to the Button component (e.g., onClick handler).
 * @returns {JSX.Element} A Button component with optional loading state.
 */
const SubmitButton = ({ isSubmitting, isSubmitSuccessful, defaultLabel="Submit", loadingLabel="Submitting...", ...rest }) => {

  return (
    <Button type='submit' disabled={isSubmitting || isSubmitSuccessful} {...rest}>
      {(isSubmitting || isSubmitSuccessful) ? (
        <>
          <Spinner animation='border' size='sm' />
          <span className='ms-2'>{loadingLabel}</span>
        </>
      ) : defaultLabel
      }
    </Button>
  );
};

export default SubmitButton;
